import { Component } from '@angular/core';
import {
  FieldWrapper,
  FormlyFieldConfig,
  FormlyModule,
} from '@ngx-formly/core';

/**
 * Wrapper padrão dos field types próprios (substitui o wrapper do
 * @ngx-formly/primeng, que renderizava label + campo num `.p-field`).
 * Label sm/medium em cima, campo embaixo, descrição e mensagem de validação
 * abaixo — mesmo visual que o CSS `.p-field > label` do styles.css produzia.
 */
@Component({
  selector: 'evolve-form-field-wrapper',
  imports: [FormlyModule],
  template: `
    @if (props.label && props['hideLabel'] !== true) {
      <label
        class="block text-sm font-medium text-foreground mb-1"
        [attr.for]="id"
      >
        {{ props.label }}
        @if (props.required && props['hideRequiredMarker'] !== true) {
          <span class="text-red-500">*</span>
        }
      </label>
    }
    <ng-container #fieldComponent />
    @if (props.description) {
      <small class="block text-muted-foreground">{{ props.description }}</small>
    }
    @if (showError) {
      <small class="block text-red-500">
        <formly-validation-message [field]="field" />
      </small>
    }
  `,
})
export class FormFieldWrapperComponent extends FieldWrapper<FormlyFieldConfig> {}
